<template>
    <form-group :name="name" :label="label" :help-text="helpText" :error="error">
        <multi-select-widget
                :name="name"
                :value="value"
                :options="options"
                :placeholder="placeholder"
                :disabled="disabled"
                @input="$emit('input', $event)"
        ></multi-select-widget>
    </form-group>
</template>

<script>
    import FormGroup from "@/vendor/forms/FormGroups/Block/FormGroup";
    import MultiSelectWidget from "../Widgets/MultiSelect";

    export default {
        components: {FormGroup, MultiSelectWidget},

        props: {
            "name": {},
            "label": {},
            "helpText": {"default": null},
            "value": {},
            "error": {},
            "options": {},
            "placeholder": {},
            "disabled": {"default": false}
        }
    }
</script>
